import * as React from "react";
import { QuotaAverageTeamMemberBar } from "./QuotaAverageTeamMemberBar";
import styled from "styled-components";

export const QuotaAvgDashboardSection = ({
  dataTeamBar,
  dataBar,
  collapsible,
}) => {
  if (!dataBar) {
    // Early exit if no data
    return <> No data found </>;
  } else {
    return (
      <QuotaAverageOuterContainer>
        {dataTeamBar && (
          <TeamChartContainer>
            <QuotaAverageTeamTotal data={dataTeamBar} />
          </TeamChartContainer>
        )}

        <QuotaAverageTeamMemberSection
          data={dataBar}
          collapsible={collapsible}
        />
      </QuotaAverageOuterContainer>
    );
  }
};

const QuotaAverageTeamTotal = ({ data }) => {
  if (data) {
    return <QuotaAverageTeamMemberBar data={data[0]} />;
  } else {
    return null;
  }
};

const QuotaAverageTeamMemberSection = ({ data, collapsible }) => {
  if (data) {
    return data.map(data => {
      return (
        <QuotaAverageTeamMemberBar
          key={data.id}
          data={data}
          collapsible={collapsible}
        />
      );
    });
  } else {
    return null;
  }
};

export const TeamChartContainer = styled.div`
  background-color: #d1d5de;
  border-bottom: 1px solid #ededed;
  padding-top: 5px;
  padding-bottom: 3px;
`;

export const QuotaAverageOuterContainer = styled.div`
  border-top: 1px solid #ededed;
`;



// WEBPACK FOOTER //
// ./app/javascript/components/commission_calculator/dashboard/QuotaAvgDashboardSection.tsx